import React from 'react';
import { Card, Col, Row, Typography } from 'antd';
import { formatPriceToman } from '../../../utils/formatPriceToman';
import {
  BankOutlined,
  RiseOutlined,
  CheckCircleOutlined,
  InboxOutlined,
  WarningOutlined
} from '@ant-design/icons';

const { Text, Title } = Typography;

const FinanceKPIs = ({ kpis, loading }) => {
  if (!kpis) return null;

  const kpiData = [
    {
      title: 'نقدینگی حاضر',
      value: kpis.current_liquid_balance,
      icon: <BankOutlined className="text-blue-500 text-2xl" />,
      bg: 'bg-blue-50 dark:bg-blue-900/20'
    },
    {
      title: 'کل فروش ماه',
      value: kpis.monthly_sales,
      icon: <RiseOutlined className="text-emerald-500 text-2xl" />,
      bg: 'bg-emerald-50 dark:bg-emerald-900/20'
    },
    {
      title: 'کل وصولی ماه',
      value: kpis.monthly_collected,
      icon: <CheckCircleOutlined className="text-emerald-500 text-2xl" />,
      bg: 'bg-emerald-50 dark:bg-emerald-900/20'
    },
    {
      title: 'چک‌های نزد صندوق',
      value: kpis.cheques_in_vault,
      icon: <InboxOutlined className="text-amber-500 text-2xl" />,
      bg: 'bg-amber-50 dark:bg-amber-900/20'
    },
    {
      title: 'چک‌های برگشتی',
      value: kpis.bounced_cheques,
      icon: <WarningOutlined className="text-red-500 text-2xl" />,
      bg: 'bg-red-50 dark:bg-red-900/20'
    }
  ];

  return (
    <Row gutter={[16, 16]} className="mb-6">
      {kpiData.map((item, index) => (
        <Col xs={24} sm={12} md={8} lg={4} key={index} className="flex-1 min-w-[200px]">
          <Card 
            loading={loading}
            bordered={false} 
            className="shadow-sm hover:shadow-md transition-all duration-300 dark:bg-gray-800 rounded-2xl overflow-hidden h-full"
            bodyStyle={{ padding: '20px' }}
          >
            <div className="flex items-center justify-between mb-4">
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.bg}`}>
                {item.icon}
              </div>
            </div>
            <div>
              <Text className="text-gray-500 dark:text-gray-400 text-sm">{item.title}</Text>
              <Title level={4} className="mt-1 mb-0" style={{ marginTop: '8px' }}>
                {formatPriceToman(item.value || 0)}
              </Title>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default FinanceKPIs;
